import React, { useState } from 'react';
import icon1 from "../../assets/img/icon/sve-icon1.png";
import icon2 from "../../assets/img/icon/sve-icon2.png";
import icon3 from "../../assets/img/icon/sve-icon3.png";
import icon4 from "../../assets/img/icon/sve-icon4.png";
import service1 from "../../assets/img/bg/D1.jpg";
import service2 from "../../assets/img/bg/D2.jpg";
import service3 from "../../assets/img/bg/K1.jpg";
import service4 from "../../assets/img/bg/K2.jpg";
import Slider from "react-slick";
import { Link } from 'react-router-dom';
import FsLightbox from 'fslightbox-react';

const roomData = [
    {
        img: service3,
        title: "Habitación con Cama King",
        description: "Amplia y lujosa habitación con cama king size, perfecta para parejas o viajeros individuales que buscan el máximo confort.",
        link: "/room-details-cama-king"
    },
    {
        img: service1,
        title: "Habitación con Camas Dobles",
        description: "Espaciosa habitación con dos camas dobles, ideal para familias o grupos pequeños que desean compartir espacio.",
        link: "/room-details-camas-dobles"
    },
    // {
    //     img: service3,
    //     title: "Habitación Suite",
    //     price: "3,500",
    //     description: "Nuestra habitación más exclusiva en el Hotel La Finca, cuenta conáreas espaciosas y todas las comodidades premium."
    // }
];



function Rooms() {
    const [toggler, setToggler] = useState(false);
    const [activeImage, setActiveImage] = useState(1);
    const [images] = useState([
        service1,
        service2,
        service3,
        service4
    ]);

    const service = {
        dots: true,
        arrows: false,
        infinite: true,
        speed: 900,
        autoplay: true,
        slidesToShow: 2,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <>
            <section id="services" className="services-area pt-113 pb-150">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-12">
                            <div className="section-title center-align mb-50 text-center">
                                <h5>Reserva tu Habitación</h5>
                                <h2>En La Finca</h2>
                                <p>Contamos con 2 tipos de habitaciones</p>
                            </div>
                        </div>
                    </div>
                    <Slider className="row services-active slider-hover-effect" {...service}>
    {roomData.map((room, index) => (
        <div key={index} className="col-xl-4 col-md-6">
            <div className="single-services mb-30">
                <div className="services-thumb">
                    <Link to="#" className="gallery-link popup-image" onClick={() => {
                        setToggler(!toggler);
                        setActiveImage(index + 1);
                    }}>
                        <img src={room.img} alt={room.title} />
                    </Link>
                </div>
                <div className="services-content">
    <h4><Link to="/room-details">{room.title}</Link></h4>
    <p>{room.description}</p>


    <div className="icon">
        <ul>
            {[icon1, icon2, icon3, icon4].map((icon, i) => (
                <li key={i}><img src={icon} alt="icon" /></li>
            ))}
        </ul>
    </div>
    <div className="room-actions text-center mt-3">
        <a href="https://us2.cloudbeds.com/en/reservation/2C4nnm?currency=mxn" className="btn" target="_blank" rel="noopener noreferrer">Reserva</a>
        <Link to={room.link} className="btn btn-outline-cafe">Ver más</Link>
</div>
</div>

            </div>
        </div>
    ))}
</Slider>

                </div>
            </section>

            <FsLightbox toggler={toggler} sources={images} slide={activeImage} />
        </>
    );
}

export default Rooms;
